<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>绩效人员快照</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.snapshot_id"
                    placeholder="请输入快照ID"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.snapshot_code"
                    placeholder="请输入快照编码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-show="postList.config_rid">
                <vDropdown
                    model_key="config_rid"
                    model_name="请选择绩效人员配置"
                    :model_value_default="queryParams['config_rid']"
                    select_value="code"
                    request_uri="dropdownPerformancePersonConfig"
                    @onDropChange="onDropChange"
                    ref="config_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="performance_unit_code"
                    model_name="请选择绩效单元"
                    :model_value_default="queryParams['performance_unit_code']"
                    request_uri="dropdownPerformanceUnit"
                    select_value="code"
                    @onDropChange="onDropChange"
                    ref="performance_unit_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="person_code"
                    model_name="请选择人员"
                    :model_value_default="queryParams['person_code']"
                    select_value="code"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="is_system"
                    model_name="是否系统创建"
                    :model_value_default="queryParams['is_system']"
                    select_value="value"
                    request_uri="yesOrNo"
                    @onDropChange="onDropChange"
                    ref="is_system_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="type_code"
                    model_name="请选择类型"
                    :model_value_default="queryParams['type_code']"
                    select_value="value"
                    request_uri="dropdownPerformanceType"
                    @onDropChange="onDropChange"
                    ref="type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="quota_type_code"
                    model_name="请选择限额分摊类型"
                    :model_value_default="queryParams['quota_type_code']"
                    select_value="value"
                    request_uri="dropdownPerformancePersonQuotaType"
                    @onDropChange="onDropChange"
                    ref="quota_type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="base_type_code"
                    model_name="请选择基数分摊类型"
                    :model_value_default="queryParams['base_type_code']"
                    select_value="value"
                    request_uri="dropdownPerformancePersonBaseType"
                    @onDropChange="onDropChange"
                    ref="base_type_code_ref"
                ></vDropdown>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>

            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="performance_person_snapshot"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['snapshot_id', 'config_rid', 'person_name', 'performance_unit_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onDelete, onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '@/components/common/Upload.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        crmUpload
    },
    name: 'performancePersonSnapshotComponent',
    data() {
        return {
            draggable: {
                data_name: 'performance_person_snapshot'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                if (this.postList.params.config_rid) {
                    this.queryParams.config_rid = this.postList.params.config_rid;
                }
                this.queryParams.row = 10;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,

        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['snapshot_id']) && row.snapshot_id) {
                this.$router.push({
                    path: '/performancePersonSnapshotDetail',
                    query: {
                        id: row.snapshot_id
                    }
                });
            } else if (in_array(prop, ['config_rid']) && row.config_rid) {
                this.$router.push({
                    path: '/performancePersonConfigDetail',
                    query: {
                        id: row.config_rid
                    }
                });
            } else if (in_array(prop, ['performance_unit_name']) && row.performance_unit_id) {
                this.$router.push({
                    path: '/performanceUnitDetail',
                    query: {
                        id: row.performance_unit_id
                    }
                });
            } else if (in_array(prop, ['person_name']) && row.person_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: row.person_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                config_rid: this.postList.params && this.postList.params.config_rid ? this.postList.params.config_rid : ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('performance_person_snapshot_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('performance_person_snapshot_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('performance_person_snapshot', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).performance_person_snapshot;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'performancePersonSnapshotLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.config_rid_ref.reset();
            this.$refs.person_code_ref.reset();
            this.$refs.is_system_ref.reset();
            this.$refs.performance_unit_code_ref.reset();
            this.$refs.type_code_ref.reset();
            this.$refs.quota_type_code_ref.reset();
            this.$refs.base_type_code_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>